//---------------------------------------------
// Unidades Educacionais Module 
//---------------------------------------------
// Módulo para gerenciar as ações da unidade

import axios from '../../services/api';
import Cookies from 'js-cookie';
var JWT = () => {
    return (Cookies.get("accessToken") ? Cookies.get("accessToken") : "JWT VAZIO")
}

// STATES
const state = () => ({
    listUE: [],
    listMacroareas: [],
    municipio: [],

    //VERIFICACAO DE ERRO
    isCreateUnidadeCSV: false,
    isCreateUnidadeWithTurmasCSV: false
})

// MUTATIONS
const mutations = {
    //-- MUTATION REQUISICAO DO LISTUNIDADESEDUCACIONAIS
    setListUE(state, payload) {
        state.listUE = payload
    },

    setMunicipio(state, payload) {
        state.municipio = payload
    },

    setIsCreateUnidadeCSV(state, payload) {
        state.isCreateUnidadeCSV = payload
    },

    setIsisCreateUnidadeWithTurmasCSV(state, payload) {
        state.isCreateUnidadeWithTurmasCSV = payload
    },

    setListMacroareas(state, payload) {
        state.listMacroareas = payload
    },

    setAddMacroarea(state, payload) {
        const counter = state?.listMacroareas[state.listMacroareas?.length - 1].counter + 1
        state.listMacroareas.push({macroarea: payload, counter: counter})
    },

    setIsUECreated(state, payload) {
        state.isUECreated = payload;
    },
}

// ACTIONS
const actions = {
    //-- ACTION REQUISICAO DE CRIAR UNIDADE EDUCACIONAL
    async setCreateUE( { commit }, payload)  {
        await axios
            .post(`ue/${payload.idMunicipio}`, {
                nome: payload.nome,
                bairro: payload.bairro,
                macroarea: payload.macroarea,
                inep: payload.inep,
                tipoLocalizacao: payload.tipoLocalizacao,
                anoInicioAtividades: payload.anoInicioAtividades,
                municipio: payload.municipio,
                rua: payload.rua,
                numero: payload.numero,
                complemento: payload.complemento,
                tipoModalidade: payload.tipoModalidade,
                idMunicipio: payload.idMunicipio
            },
                {headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
                commit('setIsUECreated', true);
            })
            .catch((error) => {
                commit('setIsUECreated', false);
                console.log(error.message)
            });
    },

    //-- ACTION REQUISICAO DE ENVIAR ARQUIVO PARA CRIAR UE
    async setSendUEFile( {commit}, payload)  {
        var formData = new FormData();
        if (payload.file) {
            formData.append("file", payload.file)
        }
        await axios
            .post(`ue/upload/${payload.idInstituicao}`, 
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
                commit('setIsCreateUnidadeCSV', true)
            })
            .catch((error) => {
                console.log(error.message)
                commit('setIsCreateUnidadeCSV', false)
            })
    },


    //-- ACTION REQUISICAO DE ENVIAR ARQUIVO PARA CRIAR UE COM TURMAS
    async setSendUEFileWithTurmas( {commit}, payload)  {
        var formData = new FormData();
        if (payload.file) {
            formData.append("file", payload.file)
        }
        await axios
            .post(`ue/uploadUeTurma/${payload.idInstituicao}`, 
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
                commit('setIsisCreateUnidadeWithTurmasCSV', true)
            })
            .catch((error) => {
                console.log(error.message)
                commit('setIsisCreateUnidadeWithTurmasCSV', false)
            })
    },

    //-- ACTION REQUISICAO DO LISTFORMS
    async setListUE({ commit }, payload) {
        await axios
            .get(`ue/${payload.idMunicipio}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListUE', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DO LISTFORMS
    async setMunicipioByUe({ commit }, payload) {
        await axios
            .get(`ue/get-municipio/${payload.id_ue}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setMunicipio', response.data)
            })
            .catch((error) => console.log(error.message))
    },



    //-- ACTION REQUISICAO DAS MACROAREAS
    async setListMacroareas({ commit }, idMunicipio) {
        await axios
            .get(`ue/listMacroareas/${idMunicipio}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListMacroareas', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION DELETE UNIDADE EDUCACIONAL
    async deleteUE(_, payload) {
        await axios
            .delete(`ue/${payload.idInstituicao}/${payload.idUE}`, {

            },{
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
            })
            .catch((error) => console.log(error.message))
    },
}

// GETTERS
const getters = {
    getListUE(state) {
        try {
            return state.listUE.data
        } catch (e) {
            return []
        }
    },

    getMunicipio(state) {
        try {
            return state.municipio.data
        } catch (e) {
            return []
        }
    },

    getListMacroareas(state) {
        try {
            return state.listMacroareas.data
        } catch (e) {
            return []
        }
    },

    getIsCreateUnidadeCSV(state) {
        return state.isCreateUnidadeCSV
    },

    getIsCreateUnidadeWithTurmasCSV(state) {
        return state.isCreateUnidadeWithTurmasCSV
    },

    getIsUECreated(state) {
        return state.isUECreated;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
